import React, { Component } from "react";
import PropTypes from "prop-types";
import { Page } from "components/ui";

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
  };
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    const persistedAuth = JSON.parse(localStorage.getItem("persist:auth") || "{}");
    const userDetails = JSON.parse(persistedAuth.user_details || "{}");
    const userId = userDetails.user_id || "";
    window.newrelic?.noticeError(error, {
      errorBoundary: true,
      location: window.location.href,
      componentStack: errorInfo.componentStack,
      userId
    });
  }

  render() {
    if (this.state.error) {
      return (
        <Page.Container>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h2 style={{ margin: "1rem", padding: "1rem", fontSize: 18 }}>
              Sorry, we seem to be having trouble
            </h2>
            <p style={{ margin: "1rem", padding: "1rem", fontSize: 16 }}>
              Our team has been notified.
            </p>
          </div>
        </Page.Container>
      );
    } else {
      return this.props.children;
    }
  }
}
